import {
  Box,
  Typography,
} from '@mui/material'
import UseTranslation from '../../hooks/UseTranslation'
import { ReactComponent as GlobeIcon } from '../../images/GlobeIcon.svg'

const Index = () => {
  const { toggleAllLanguages, language } = UseTranslation()
  const nextLanguageLabel = language === 'EN' ? 'AR-العربية' : 'EN-English'

  return (
    <Box
      sx={styles.root}
      onClick={toggleAllLanguages}
    >
        <Box sx={styles.toggleIcon}>
        <GlobeIcon />
      </Box>
      <Typography sx={styles.textStyle}>
        {nextLanguageLabel}
      </Typography>

    </Box>

  )
}
const styles = {
  root: {

    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  textStyle: {
    fontSize: { xs: '14px !important', sm: '17px !important' },
  },
}

export default Index
